import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { AgendaManager } from "@/components/admin/AgendaManager";

export const Route = createFileRoute("/admin/agenda")({
  component: AgendaPage,
  head: () => ({
    meta: [
      { title: "Agenda — Admin" },
      { name: "description", content: "Manage event agenda and schedule" },
    ],
  }),
});

function AgendaPage() {
  return (
    <AdminLayout>
      <AgendaManager />
    </AdminLayout>
  );
}
